import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

export const pricingService = {
  calculatePrice: async (formData) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CALCULATE_PRICE, {
        sqft: formData.sqft,
        bedrooms: formData.bedrooms,
        bathrooms: formData.bathrooms,
        frequency: formData.frequency,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error calculating price. Please try again later.',
      };
    }
  },
};

export default pricingService;
